import './NotFoundPage.css';

import React from 'react';

export default function NotFoundPage() {
  return (
    <div className="notfound-container">
      <h2>Page not found</h2>
    </div>
  );
}
